<template>
  <el-popover
    placement="top-start"
    :title="origin | ucwords"
    width="200"
    trigger="hover"
  >
    <div
      slot="reference"
      class="text-center"
    >
      <img
        class="origin-icon"
        :src="originIcon"
        :alt="origin | ucwords"
      >
    </div>
  </el-popover>
</template>

<script>
export default {
  name: 'OriginIcon',
  props: {
    origin: {
      type: String,
      default: ''
    }
  },
  computed: {
    originIcon() {
      try {
        return require('@/assets/icons/origins/' + this.origin.toLowerCase() + '.png')
      }
      catch (e) {
        console.log('origin icon not found!')
      }
      return require('@/assets/icons/origins/owiwi-partner.png')
    }
  }
}
</script>

<style lang="scss" scoped>
.origin-icon {
  position: relative;
  top: 3px;
  max-width: 40px;
  max-height: 40px;
}
</style>
